import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const PasswordInput = () => {
  return (
    <VpHookFormInput
      maxLength={100}
      required
      name="password"
      type="password"
      placeholder="Password"
    />
  );
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-in/PasswordInput.jsx